import { render, staticRenderFns } from "./BakedCompo.vue?vue&type=template&id=55c64798&scoped=true&"
import script from "./BakedCompo.vue?vue&type=script&lang=js&"
export * from "./BakedCompo.vue?vue&type=script&lang=js&"
import style0 from "./BakedCompo.vue?vue&type=style&index=0&id=55c64798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c64798",
  null
  
)

export default component.exports